<template>
  <div class="new-production" style="padding-bottom:70px;">
    <div class="page-width">
      <div class="left">
        <div class="production">
          <h1>买菜卖菜上美菜</h1>
          <p style="font-size:16px; margin-top:10px; line-height:28px;">
            <span>源头直采</span>
            <span>品类万千</span>
            <span>新鲜低价</span>
            <br />
            <span>闪速下单</span>
            <span>送货上门</span>
            <span>专职销售</span>
            <span>热心客服</span>
          </p>
        </div>
        <div class="service">
          <p
            style="font-size:16px; margin-top:10px; line-height:28px; text-align:justify"
          >美菜致力于用前卫的理念和先进的科技改变落后的国内农业市场，专注为全国近百万家餐厅，提供全品类、全程无忧的餐饮食材采购服务。</p>
        </div>
        <div class="down-code" style="margin-top:50px;">
          <ul>
            <li>
              <span class="client">客户端下载</span>
              <div class="client-code">
                <img src="@/assets/images/new-img/home/mc-app.png" width="162" />
              </div>
            </li>
            <li>
              <span class="mall">关注微信商城</span>
              <div class="client-code">
                <img src="@/assets/images/new-img/home/mc-wx.png" width="162" />
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="right">
        <img src="@/assets/images/new-img/home/picture.png" />
      </div>
      <div class="clear"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "product"
};
</script>

<style lang="scss" scoped>
.new-production {
  background: #fff;
  padding: 100px 0;
  .page-width {
    width: 1050px;
    margin: 0 auto;
  }
  .left {
    width: 455px;
    float: left;
    .production {
      h1 {
        font-size: 40px;
      }
      p {
        margin-top: 20px;
        font-size: 20px;
        color: #757575;
        span {
          margin-right: 30px;
        }
      }
    }
    .service {
      margin-top: 60px;
    }
    .down-code {
      margin-top: 100px;
      ul {
        font-size: 0;
        li {
          display: inline-block;
          width: 180px;
          height: 48px;
          border: 1px solid #75bc46;
          border-radius: 24px;
          font-size: 18px;
          cursor: pointer;
          color: #75bc46;
          margin-right: 20px;
          line-height: 46px;
          position: relative;
          &:hover .client-code {
            left: 50%;
            opacity: 1;
          }
          .client {
            display: block;
            background: url(../../../assets/images/new-img/home/down-icon.png)
              no-repeat 132px center;
            background-size: 26px 24px;
            text-indent: 25px;
            position: absolute;
            width: 180px;
            z-index: 10;
          }
          .client-code {
            position: absolute;
            top: 25px;
            left: -9999px;
            margin-left: -90px;
            border: 1px solid #75bc46;
            border-top: 0;
            border-bottom-left-radius: 5px;
            border-bottom-right-radius: 5px;
            width: 180px;
            text-align: center;
            background: #fff;
            text-indent: 0;
            padding: 25px 0 5px;
            opacity: 0;
            transition: opacity 0.3s;
          }
          .mall {
            display: block;
            background: url(../../../assets/images/new-img/home/shop-icon.png)
              no-repeat 136px center;
            background-size: 26px 24px;
            text-indent: 18px;
            position: absolute;
            width: 180px;
            z-index: 10;
          }
        }
      }
    }
  }
  .right {
    float: right;
  }
}
.clear {
  clear: both;
  height: 0;
  font-size: 0;
  overflow: hidden;
  width: 100%;
}
</style>
